export default "__VITE_ASSET__BT_VqSEe__"